// Axios
import Axios from "./axios";

export const fetchTestimonials = (order) => {
  return new Promise((resolve, reject) => {
    const data = Axios.get(`/workshopTestimonial`, { params: { order } });
    resolve(data);
  });
};
